import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import { InvalidSessionError } from '../components/invalid-session/invalid-session-error';
import { KlageKvittering } from '../components/kvittering/klage-kvittering';
import { SignertFullmakt } from '../components/kvittering/signert-fullmakt';
import SkademeldingKvittering from '../components/kvittering/skademelding-kvittering';
import Ettersending from '../ettersending/ettersending';
import { EttersendingKvittering } from '../ettersending/kvittering/ettersending-kvittering';
import { Klage } from '../klage/klage';
import {
    Bat,
    BygningNaturskade,
    DegOgDineUforhetDodsfallEllerKritiskSykdom,
    Kjoretoy,
    Landbruk,
    Landingsside,
    Naring,
    Partner,
    Reise,
    ReiseMistetSkadetStjalet,
} from '../landingsside';
import { Ansvar } from '../landingsside/ansvar/ansvar';
import { AnsvarUnderkategori } from '../landingsside/ansvar/ansvar-underkategori';
import { BatKollisjonsskade } from '../landingsside/bat/bat-kollisjonsskade';
import { TyveriEllerInnbrudd } from '../landingsside/bat/bat-tyveri-eller-innbrudd';
import { Bygning } from '../landingsside/bygning/bygning';
import { BygningBrannOgElektriskeSkader } from '../landingsside/bygning/bygning-brann-og-elektriske-skader';
import { BygningGlasskade } from '../landingsside/bygning/bygning-glasskade';
import { BygningInnbruddOgHarverk } from '../landingsside/bygning/bygning-innbrudd-og-harverk';
import { BygningLekkasjerOgVannskader } from '../landingsside/bygning/bygning-lekkasjer-og-vannskader';
import { SoppRateSkadedyrInfo } from '../landingsside/bygning/sopp-rate-skadedyr-info';
import { DeeplinkHandler } from '../landingsside/deep-link-handler';
import { Dyr } from '../landingsside/dyr/dyr';
import { Hest } from '../landingsside/dyr/hest';
import { Hund } from '../landingsside/dyr/hund';
import { Katt } from '../landingsside/dyr/katt';
import { InnboOgEiendeler } from '../landingsside/innbo-og-eiendeler/innbo-og-eiendeler';
import { KjoretoyAndreSkader } from '../landingsside/kjoretoy/kjoretoy-andre-skader';
import { KollisjonskadePaKjoretoy } from '../landingsside/kjoretoy/kjoretoy-kollisjonsskade-pa-bil';
import { KjoretoySkadePaParkertKjoretoy } from '../landingsside/kjoretoy/kjoretoy-skade-pa-parkert-kjoretoy';
import { KjoretoyTyveri } from '../landingsside/kjoretoy/kjoretoy-tyveri';
import { LandbrukDriftsbygninger } from '../landingsside/landbruk/landbruk-driftsbygninger';
import { LandbrukLosoreEiendel } from '../landingsside/landbruk/landbruk-losore-eiendel';
import { Produksjonsdyr } from '../landingsside/landbruk/produksjonsdyr';
import { NaringLosoreEiendeler } from '../landingsside/naring/naring-losore-eiendeler';
import { NaringNaringsbyggOgEiendeler } from '../landingsside/naring/naring-naringsbygg-og-eiendeler';
import { partnerUrler } from '../landingsside/partner/partner-urler';
import { ReiseSykdomUlykkeDodsfall } from '../landingsside/reise/reise-sykdom-ulykke-dodsfall';
import { Rettshjelp } from '../landingsside/rettshjelp/rettshjelp';
import { RettshjelpPrivat } from '../landingsside/rettshjelp/rettshjelp-privat';
import { Skademelding } from '../meldskade/skademelding';
import { urler } from './router-urler';

const {
    landingssideUrl,
    meldSkadeUrl,
    ettersendingUrl,
    klageUrl,
    husOgHytteUrl,
    bygningGlasskadeUrl,
    bygningLekkasjerOgVannskaderUrl,
    bygningBrannOgElektriskeSkaderUrl,
    bygningNaturskadeUrl,
    bygningInnbruddOgHarverkSkaderUrl,
    soppRateSkadedyr,
    innboOgEiendelerUrl,
    degOgDineUforhetDodsfallEllerKritiskSykdomUrl,
    reiseUrl,
    kjoretoyUrl,
    klageKvitteringUrl,
    kollisjonskadeKjoretoyUrl,
    kjoretoyTyveriUrl,
    skadePaParkertKjoretoyUrl,
    andreSkaderKjoretoyUrl,
    batUrl,
    batKollisjonsskadeUrl,
    batTyveriEllerInnbruddUrl,
    naringUrl,
    naringNaringsbyggOgEiendelerUrl,
    naringLosoreEiendelUrl,
    landbrukUrl,
    landbrukProduksjonsdyrUrl,
    landbrukLosoreEiendelUrl,
    landbrukDriftsbygningerUrl,
    sporsmalsflytKvitteringUrl,
    ettersendingKvitteringUrl,
    signertFullmakt,
    reiseMistetSkadetStjaletUrl,
    reiseSykdomUlykkeDodsfallUrl,
    dyrUrl,
    kattUrl,
    hundUrl,
    hestUrl,
    rettshjelpUrl,
    rettshjelpPrivatUrl,
    ansvarUrl,
    ansvarPrivatUrl,
    ansvarLandbrukNaringUrl,
    invalidSessionUrl,
} = urler();

export const AppRouter: React.FC = () => (
    <div id="forsikring-meld-skade-web" className="meld-skade">
        <Router>
            <Routes>
                <Route
                    path={landingssideUrl}
                    element={
                        <DeeplinkHandler>
                            <Landingsside />
                        </DeeplinkHandler>
                    }
                />

                <Route path={meldSkadeUrl} element={<Skademelding />} />
                <Route path={ettersendingUrl} element={<Ettersending />} />
                <Route path={klageUrl} element={<Klage />} />

                <Route path={bygningNaturskadeUrl} element={<BygningNaturskade />} />
                <Route path={husOgHytteUrl} element={<Bygning />} />
                <Route path={bygningLekkasjerOgVannskaderUrl} element={<BygningLekkasjerOgVannskader />} />
                <Route path={bygningBrannOgElektriskeSkaderUrl} element={<BygningBrannOgElektriskeSkader />} />
                <Route path={bygningInnbruddOgHarverkSkaderUrl} element={<BygningInnbruddOgHarverk />} />
                <Route path={bygningGlasskadeUrl} element={<BygningGlasskade />} />
                <Route path={soppRateSkadedyr} element={<SoppRateSkadedyrInfo />} />
                <Route path={innboOgEiendelerUrl} element={<InnboOgEiendeler />} />

                <Route
                    path={degOgDineUforhetDodsfallEllerKritiskSykdomUrl}
                    element={<DegOgDineUforhetDodsfallEllerKritiskSykdom />}
                />

                <Route path={reiseUrl} element={<Reise />} />
                <Route path={reiseMistetSkadetStjaletUrl} element={<ReiseMistetSkadetStjalet />} />
                <Route path={reiseSykdomUlykkeDodsfallUrl} element={<ReiseSykdomUlykkeDodsfall />} />

                <Route path={kjoretoyUrl} element={<Kjoretoy />} />
                <Route path={kollisjonskadeKjoretoyUrl} element={<KollisjonskadePaKjoretoy />} />
                <Route path={kjoretoyTyveriUrl} element={<KjoretoyTyveri />} />
                <Route path={skadePaParkertKjoretoyUrl} element={<KjoretoySkadePaParkertKjoretoy />} />
                <Route path={andreSkaderKjoretoyUrl} element={<KjoretoyAndreSkader />} />
                <Route path={batUrl} element={<Bat />} />
                <Route path={batKollisjonsskadeUrl} element={<BatKollisjonsskade />} />
                <Route path={batTyveriEllerInnbruddUrl} element={<TyveriEllerInnbrudd />} />
                <Route path={naringUrl} element={<Naring />} />
                <Route path={naringNaringsbyggOgEiendelerUrl} element={<NaringNaringsbyggOgEiendeler />} />
                <Route path={naringLosoreEiendelUrl} element={<NaringLosoreEiendeler />} />
                <Route path={landbrukUrl} element={<Landbruk />} />
                <Route path={landbrukLosoreEiendelUrl} element={<LandbrukLosoreEiendel />} />
                <Route path={landbrukDriftsbygningerUrl} element={<LandbrukDriftsbygninger />} />
                <Route path={landbrukProduksjonsdyrUrl} element={<Produksjonsdyr />} />

                <Route path={dyrUrl} element={<Dyr />} />
                <Route path={kattUrl} element={<Katt />} />
                <Route path={hundUrl} element={<Hund />} />
                <Route path={hestUrl} element={<Hest />} />

                <Route path={rettshjelpUrl} element={<Rettshjelp />} />
                <Route path={rettshjelpPrivatUrl} element={<RettshjelpPrivat />} />

                <Route path={ansvarUrl} element={<Ansvar />} />
                <Route path={ansvarPrivatUrl} element={<AnsvarUnderkategori isPrivat />} />
                <Route path={ansvarLandbrukNaringUrl} element={<AnsvarUnderkategori isPrivat={false} />} />

                <Route path={sporsmalsflytKvitteringUrl} element={<SkademeldingKvittering />} />
                <Route path={ettersendingKvitteringUrl} element={<EttersendingKvittering />} />
                <Route path={klageKvitteringUrl} element={<KlageKvittering />} />

                <Route path={`${partnerUrler.root}/*`} element={<Partner />} />

                <Route path={signertFullmakt} element={<SignertFullmakt />} />
                <Route path={invalidSessionUrl} element={<InvalidSessionError />} />
            </Routes>
        </Router>
    </div>
);
